var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "nav__link nav__link--bookmark",
      class: {
        "is-bookmarked": _vm.isBookmarked,
        "is-disabled": !_vm.articleData.loggedIn,
      },
      attrs: {
        id: "set-bookmark",
        tabindex: "0",
        "aria-disabled": !_vm.articleData.loggedIn,
        "aria-label": _vm.isBookmarked
          ? "Lesezeichen anzeigen"
          : "Lesezeichen erstellen",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.addBookmark()
        },
      },
    },
    [_c("span", { staticClass: "nav__text" }, [_vm._v("Lesezeichen")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }